import {AutoPlayButtonView} from '@fantasmagames/slot/src/modules/keypad/autoplay/AutoPlayButtonView';
import {ModuleState} from '@fantasmagames/slot/src/common/ModuleState';
import {AutoPlayButtonModule} from '@fantasmagames/slot/src/modules/keypad/autoplay/AutoPlayButtonModule';
import {StopAutoplayButtonEvents} from '@fantasmagames/slot/src/modules/keypad/stopautoplaybutton/StopAutoplayButtonEvents';
import {FlowModuleEvents} from '@fantasmagames/slot/src/modules/flow/FlowModuleEvents';

export class AutoPlayButtonBasicState extends ModuleState<AutoPlayButtonView, AutoPlayButtonModule> {
	public onEnterState(): void {
		if (!this.module.autoPlayActive && this.module.startscreenExitFinished && !this.module.logic.isFreeSpinsStarted && !this.module.logic.isFreeSpinsJustWon()) {
			this.module.showAutoplayButton();
		}
		this.module.enableAutoplayButton();
	}

	public onLeaveState(): void {
	}

	protected setupEvents(): void {
		this.on(FlowModuleEvents.CAN_SPIN, this.onCanSpin);
		this.on(StopAutoplayButtonEvents.STOP_AUTOPLAY_BUTTON_CLICKED, this.onStopAutoplayButtonClicked);
	}

	protected onCanSpin(): void {
		if (this.module.isFreeSpins) {
			return;
		}

		if (!this.module.autoPlayActive && this.module.startscreenExitFinished) {
			this.module.showView();
			this.module.showAutoplayButton();
		}
		this.module.enableAutoplayButton();
	}

	protected onStopAutoplayButtonClicked(): void {
		this.module.autoPlayActive = false;
		this.module.showAutoplayButton();
	}

}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/modules/keypad/autoplay/states/AutoPlayButtonBasicState.ts